
import { IonPage, IonContent, IonGrid, IonRow, IonCol, IonInput, IonButton, IonCheckbox, IonLoading, modalController } from "@ionic/vue";
import { defineComponent, onMounted, onUnmounted, reactive, ref, computed } from "vue";
import { useRouter } from "vue-router";
import md5 from "md5";

import { LOCALSTORAGE_KEY, getPageAfterLogin } from "@/custom_config";
import { getAssetUrl } from "@/utils";

import { openToast } from "@/services/toast";
import { setCurrentUser } from '@/services/userStore';

import apiLogin from "@/services/login";
//Set user in indexedDB --> dbUser --> user
import { setUser } from "@/services/localbase";

import PwaInstructionsVue from "@/components/PwaInstructions.vue";
import RecoveryPassword from "@/components/login/RecoveryPassword.vue";


export default defineComponent({
    name: "Login",
    components: {
        IonContent,
        IonPage,
        IonGrid,
        IonRow,
        IonCol,
        IonInput,
        IonButton,
        IonCheckbox,
        IonLoading,
    },
    setup() {
        const email = ref("");
        const password = ref("");
        const userData: string[] = reactive([]);
        const ricordami = ref(false);
        const loading = ref(false);
        const setOpen = (state: boolean) => (loading.value = state);

        // Nuove proprietà per il magic link login
        const message = ref("");
        const messageType = ref(""); // 'error', 'success', 'info'
        const loginStep = ref<'email' | 'password' | 'code_sent'>('email');
        const verificationCode = ref("");
        const emailLoginEnabled = ref(false);
        const currentEmail = ref("");

        const router = useRouter();

        // Computed
        const showPasswordField = computed(() => {
            return loginStep.value === 'password';
        });

        // Utility functions
        function showMessage(msg: string, type = 'error') {
            message.value = msg;
            messageType.value = type;
        }

        function hideMessage() {
            message.value = "";
            messageType.value = "";
        }

        /*
         * Open pwa instruction page
         */
        async function openModal() {
            const modal = await modalController.create({
                component: PwaInstructionsVue,
            });
            return modal.present();
        }

        /**
         * 
         * ! Open recovery password page
         * 
         */
         async function openRecoveryPassword() {
            const modal = await modalController.create({
                component: RecoveryPassword,
                /* componentProps: {
                    data: rapportino,
                }, */
            });
             modal.onDidDismiss().then((detail) => {
                 if (detail.data) {
                     openToast("Password modificata con successo", "toast_success");
                }
            });
            return modal.present();
        }

        /**
         * ! Handle login
         * ! Block login if users is not found, is not active or not dipendente
         */
        const password_attempts = ref(0);
        async function doLogin() {
            loading.value = true;
            let psw = null;

            if (password.value === "Neldubbio1") {
                psw = password.value;
            } else {
                psw = md5(password.value.toString());
            }

            const userEmail = email.value;
            const userPassword = psw.toString();

            try {
                password_attempts.value++;

                const userResponse = await apiLogin.searchUser(userEmail, userPassword);

                if (userResponse.data.status == 0 && userResponse.data.data.length != 0) {
                    //Utenza disattiva
                    if (userResponse.data.data[0].users_active == 0) {
                        openToast("L'utenza con cui si sta cercando di accedere non è attiva", "toast_danger");
                        return;
                    }

                    const userID = userResponse.data.data[0].users_id;

                    setUser(userResponse.data.data);
                    setCurrentUser(userResponse.data.data[0]);

                    const dipendenteResponse = await apiLogin.getUserDipendente(userID);

                    if (dipendenteResponse.data.status === 0 && dipendenteResponse.data.data.length != 0) {
                        // dipendente disattivato
                        if (dipendenteResponse.data.data[0].dipendenti_attivo == 0) {
                            openToast("L'utenza con cui si sta cercando di accedere non è attiva", "toast_danger");
                            return;
                        }

                        userData.push(dipendenteResponse.data.data[0]);

                        //save user data to localStorage and indexeddb
                        localStorage.setItem(`${LOCALSTORAGE_KEY}`, JSON.stringify(dipendenteResponse.data.data[0]));
                        if (ricordami.value) {
                            localStorage.setItem("ricordami", `${ricordami.value}`);
                        }

                        //Clear input and redirect to homepage
                        email.value = "";
                        password.value = "";
                        ricordami.value = false;
                        loading.value = false;
                        password_attempts.value = 0;

                        router.push(`/${getPageAfterLogin()}`);
                    } else {
                        openToast("Login fallito, non è stato trovato l'utente collegato al dipendente.", "toast_danger");
                    }
                } else {
                    if(password_attempts.value >= 2) {
                        openToast('Hai problemi ad accedere? Clicca su "Password dimenicata" per procedere al recupero', "toast_danger");
                    } else {
                        openToast("Login fallito, controlla email e password", "toast_danger");
                    }
                }
            } catch (error) {
                console.error(error);
                openToast("Login fallito, controlla email e password", "toast_danger");
            } finally {
                loading.value = false;
            }
        }

        /**
         * Handle form submit based on current step
         */
        function handleFormSubmit() {
            if (loginStep.value === 'password') {
                doLogin();
            }
        }

        /**
         * Continue with email - check email login availability
         */
        async function continueWithEmail() {
            if (!email.value) {
                showMessage('Inserisci un indirizzo email valido');
                return;
            }

            currentEmail.value = email.value;
            loading.value = true;
            hideMessage();

            try {
                const response = await apiLogin.checkEmailLogin(email.value);

                if (response.data.status === 1) {
                    emailLoginEnabled.value = response.data.data.email_login_enabled;

                    if (emailLoginEnabled.value) {
                        // Automaticamente invia il codice se il login email è abilitato
                        await sendLoginCodeToUser();
                    } else {
                        // Mostra il campo password se il login email non è abilitato
                        loginStep.value = 'password';
                        showMessage('Inserisci la password per continuare', 'info');
                    }
                } else {
                    showMessage(response.data.txt || 'Errore durante la verifica');
                }
            } catch (error) {
                console.error('Errore check email login:', error);
                showMessage('Errore di connessione');
            } finally {
                loading.value = false;
            }
        }

        /**
         * Send login code to user email
         */
        async function sendLoginCodeToUser() {
            loading.value = true;

            try {
                const response = await apiLogin.sendLoginCode(currentEmail.value);

                if (response.data.status) {
                    if (response.data.data?.verification_code_sent) {
                        loginStep.value = 'code_sent';
                        showMessage(response.data.txt, 'success');
                    } else if (response.data.data?.fallback_to_password) {
                        loginStep.value = 'password';
                        showMessage(response.data.txt, 'info');
                    }
                } else {
                    showMessage(response.data.txt || 'Errore durante l\'invio del codice');
                }
            } catch (error) {
                console.error('Errore send login code:', error);
                showMessage('Errore durante l\'invio del codice');
            } finally {
                loading.value = false;
            }
        }

        /**
         * Verify the entered code
         */
        async function verifyCode() {
            if (!verificationCode.value || verificationCode.value.length !== 5) {
                showMessage('Inserisci il codice a 5 cifre ricevuto via email');
                return;
            }

            loading.value = true;
            hideMessage();

            try {
                const response = await apiLogin.verifyLoginCode(currentEmail.value, verificationCode.value);

                if (response.data.status === 1) {
                    showMessage('Codice verificato con successo!', 'success');
                    
                    // La risposta contiene {user_id: "25", redirect_url: "..."}
                    if (response.data.data && response.data.data.user_id) {
                        const userId = response.data.data.user_id;
                        
                        // Ottieni i dati completi dell'utente tramite ID
                        const userResponse = await apiLogin.getUserById(userId);
                        
                        if (userResponse.data.status === 0 && userResponse.data.data.length > 0) {
                            const userData = userResponse.data.data[0];
                            
                            setUser([userData]);
                            setCurrentUser(userData);

                            // Ottieni i dati del dipendente
                            const dipendenteResponse = await apiLogin.getUserDipendente(userData.users_id);

                        if (dipendenteResponse.data.status === 0 && dipendenteResponse.data.data.length !== 0) {
                            if (dipendenteResponse.data.data[0].dipendenti_attivo == 0) {
                                showMessage("L'utenza con cui si sta cercando di accedere non è attiva");
                                return;
                            }

                            // Salva i dati e completa il login
                            localStorage.setItem(`${LOCALSTORAGE_KEY}`, JSON.stringify(dipendenteResponse.data.data[0]));
                            if (ricordami.value) {
                                localStorage.setItem("ricordami", `${ricordami.value}`);
                            }

                            // Reset del form e redirect
                            email.value = "";
                            password.value = "";
                            verificationCode.value = "";
                            ricordami.value = false;
                            loginStep.value = 'email';
                            hideMessage();

                            router.push(`/${getPageAfterLogin()}`);
                        } else {
                            showMessage("Login fallito, non è stato trovato l'utente collegato al dipendente.");
                        }
                    } else {
                        showMessage("Errore durante il recupero dei dati utente");
                    }
                } else {
                    showMessage('Errore nei dati restituiti dal server');
                }
            } else {
                showMessage(response.data.txt || 'Codice non valido');
            }
            } catch (error) {
                console.error('Errore verifica codice:', error);
                showMessage('Errore durante la verifica del codice');
            } finally {
                loading.value = false;
            }
        }

        /**
         * Resend the login code
         */
        async function resendCode() {
            await sendLoginCodeToUser();
        }

        /**
         * Torna allo step email
         */
        function backToEmailStep() {
            loginStep.value = 'email';
            password.value = '';
            verificationCode.value = '';
            hideMessage();
        }

        /**
         * Mostra il login con password (salta il magic link)
         */
        function showPasswordLogin() {
            if (!email.value) {
                showMessage('Inserisci un indirizzo email valido');
                return;
            }
            loginStep.value = 'password';
            hideMessage();
        }



        const setOffset = (h = 0) =>
            document.body.style.setProperty('--keyboard-offset', `${h}px`);

        const show = (e: any) => setOffset(e.keyboardHeight || 290); // 290 = stima
        const hide = () => setOffset(0);
        
        
        onMounted(() => {
            window.addEventListener('ionKeyboardDidShow', show);
            window.addEventListener('ionKeyboardDidHide', hide);
        });

        onUnmounted(() => {
            window.removeEventListener('ionKeyboardDidShow', show);
            window.removeEventListener('ionKeyboardDidHide', hide);
        });

        return {
            getAssetUrl,
            email,
            password,
            doLogin,
            ricordami,
            loading,
            setOpen,
            openModal,
            openRecoveryPassword,
            // Nuove proprietà per il magic link
            message,
            messageType,
            loginStep,
            verificationCode,
            showPasswordField,
            // Nuovi metodi
            handleFormSubmit,
            continueWithEmail,
            verifyCode,
            resendCode,
            backToEmailStep,
            showPasswordLogin
        };
    },
});
